(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-section-slider"] && !Shopify.designMode) return;
  try {
    
  if (!window.__swiper_loaded__) {
    window.__swiper_loaded__ = true;

    const swiperCSS = document.createElement('link');
    swiperCSS.rel = 'stylesheet';
    swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(swiperCSS);

    const swiperJS = document.createElement('script');
    swiperJS.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    swiperJS.onload = () => {
      const swiper = new Swiper('.swiper', {
        loop: true,
        autoplay: {
          delay: 3000, // 3 seconds
          disableOnInteraction: false // keeps autoplay after user interaction
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });
    };
    document.body.appendChild(swiperJS);
  }

  

  } catch(e) { console.error(e); }
})();
})();
